export default "__VITE_ASSET__C5K5g8Ny__"